const messageType = {
    CHAT: 'CHAT',
    ANNOTATION: 'ANNOTATION',
    UPLOAD: 'UPLOAD',
}

export {
    messageType,
}